import React from 'react'

export default function AdminFooter() {
  return (
    <div></div>
  )
}
